import React from 'react';
import { LayoutDashboard, Users, Flame, BarChart3, Radio, Settings } from 'lucide-react';

interface Props {
  page:      string;
  setPage:   (p: string) => void;
  connected: boolean;
  hotCount:  number;
}

export function Sidebar({ page, setPage, connected, hotCount }: Props) {
  const nav = (id: string, label: string, Icon: any, badge?: number) => (
    <button
      key={id}
      className={`nav-item ${page === id ? 'active' : ''}`}
      onClick={() => setPage(id)}
    >
      <Icon size={15} />
      {label}
      {badge ? <span className="nav-badge">{badge}</span> : null}
    </button>
  );

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <h1>monashi.ai</h1>
        <p>visitor intelligence</p>
      </div>

      <nav className="sidebar-nav">
        <span className="nav-section">Overview</span>
        {nav('overview',  'Dashboard',    LayoutDashboard)}
        {nav('live',      'Live Feed',    Radio)}

        <span className="nav-section">Visitors</span>
        {nav('sessions',  'All Sessions', Users)}
        {nav('leads',     'Hot Leads',    Flame, hotCount || undefined)}

        <span className="nav-section">Insights</span>
        {nav('analytics', 'Analytics',   BarChart3)}
        {nav('settings',  'Settings',    Settings)}
      </nav>

      <div className="sidebar-footer">
        <div className="ws-status">
          <div className={`ws-dot ${connected ? 'connected' : ''}`} />
          {connected ? 'Live connected' : 'Disconnected'}
        </div>
      </div>
    </aside>
  );
}
